module.exports = __webpack_public_path__ + "static/media/exclamation-triangle.4f0218a7.svg";